import React from "react";
import { Paper, Typography } from "@material-ui/core";

const AddConnectionCard = ({ onClick, classes, theme }) => (
  <Paper className={classes.addConnectionCard} onClick={onClick}>
    <Typography className={classes.addConnectionText}>
      <span style={{ fontSize: '32px', marginRight: theme.spacing(1) }}>+</span>
      Agregar Conexión
    </Typography>
  </Paper>
);

export default AddConnectionCard;
